import { __awaiter } from "tslib";
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    entities: [],
    pages: [],
    loading: 'idle',
    error: null
};
export var AnnouncementsActionType;
(function (AnnouncementsActionType) {
    AnnouncementsActionType["FetchAnnouncementPage"] = "announcements/fetchAnnouncementPage";
})(AnnouncementsActionType || (AnnouncementsActionType = {}));
export const fetchAnnouncementPage = createAsyncThunk(AnnouncementsActionType.FetchAnnouncementPage, (page, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const response = yield api.getAnnouncementPage(page);
        const settings = Object.assign({}, response);
        delete settings.announcements;
        const entities = response.announcements;
        const payload = { settings, entities, page };
        return payload;
    }
    catch (err) {
        return rejectWithValue({ error: err, page });
    }
}));
const announcementsSlice = createSlice({
    name: ReducerType.Announcements,
    initialState,
    reducers: {
        resetAnnouncements: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(fetchAnnouncementPage.fulfilled, (state, action) => {
            const { page } = action.payload;
            const pages = state.pages
                ? state.pages.filter(i => i.page !== page)
                : [];
            state.pages = [...pages, action.payload];
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchAnnouncementPage.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchAnnouncementPage.rejected, (state, action) => {
            const { error, page } = action.payload || {};
            state.error = error;
            (state.pages = state.pages.filter(i => i.page !== page)),
                (state.loading = 'idle');
        });
    }
});
export const { resetAnnouncements } = announcementsSlice.actions;
export const selectAnnouncements = (state) => state.announcements;
export const selectAnnouncementsPage = (page) => createSelector((state) => {
    const { pages, loading, error } = state.announcements;
    return { pages, loading, error };
}, ({ pages, loading, error }) => {
    const data = pages ? pages.find(i => i.page === page) : undefined;
    const { settings = null, entities = [] } = data || {};
    return { settings, entities, loading, error };
});
export const selectHasAnnouncementsPage = (page) => createSelector((state) => {
    const { pages, loading } = state.announcements;
    return { pages, loading };
}, ({ pages, loading }) => {
    const data = pages ? pages.find(i => i.page === page) : undefined;
    const { entities = [] } = data || {};
    const hasAnnouncements = entities && entities.length;
    return loading === 'pending' || hasAnnouncements ? true : false;
});
export const announcementsReducer = announcementsSlice.reducer;
